import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=f37e93c8"
import script from "./FormFooter.vue?vue&type=script&lang=js"
export * from "./FormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports